"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBadgeWithModal = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var HeaderBadge_1 = require("./HeaderBadge");
/**
 * @internal
 */
exports.HeaderBadgeWithModal = function (_a) {
    var renderModalContent = _a.renderModalContent, children = _a.children, color = _a.color, badgeProps = tslib_1.__rest(_a, ["renderModalContent", "children", "color"]);
    var _b = tslib_1.__read(react_1.useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    return (react_1.default.createElement(HeaderBadge_1.HeaderBadge, tslib_1.__assign({}, badgeProps),
        react_1.default.createElement("button", { type: "button", style: { color: color }, className: "gd-header-badge-button", onClick: function () { return setIsModalOpen(true); } }, children),
        isModalOpen ? renderModalContent({ closeModal: function () { return setIsModalOpen(false); } }) : null));
};
//# sourceMappingURL=HeaderBadgeWithModal.js.map